module.exports = __webpack_public_path__ + "static/media/HUAWEI.1f31c6f3.svg";